import { composeValidators, validate } from '@alfa-bank/site-form-helpers/validation/utils';
import { validateNotEmpty } from '@alfa-bank/site-form-helpers/validation/not-empty';
import type { TValidatorValue } from '@alfa-bank/site-form-helpers/src/validation/models';
import { DEFAULT_PHONE_MESSAGE } from '@alfa-bank/site-form-helpers/validation/phone';
import { isValidAlfaPhone } from '@alfa-bank/site-form-helpers/validation/alfa-phone';

const validateAlfaPhoneValue = (value: TValidatorValue) =>
    validate(isValidAlfaPhone(value), DEFAULT_PHONE_MESSAGE);

export const strForRegExp940 = '^(?!\\+7 \\(940)';
export const message940 = 'Телефон указан неверно.';

export const validate940 = (value: string) =>
    validate(new RegExp(strForRegExp940).test(value), DEFAULT_PHONE_MESSAGE, message940);

export const strForRegExp79 = '^\\+7 \\(9';
export const message79 = 'Телефон указан неверно. Должен начинаться с +7 (9 ';

export const validate79 = (value: string) =>
    validate(new RegExp(strForRegExp79).test(value), DEFAULT_PHONE_MESSAGE, message79);

export const validatePhone = () =>
    composeValidators(validateNotEmpty(), validateAlfaPhoneValue, validate79);

export const validatePhoneReject940 = () =>
    composeValidators(validateNotEmpty(), validateAlfaPhoneValue, validate940, validate79);
